import { useTranslation } from "react-i18next";
import { Container } from 'react-bootstrap'
import PageDefault from 'components/PageDefault';
import CardArea from 'components/Card/CardArea';
import CardSimple from 'components/Card/CardSimple';
import CardMoney from 'components/Card/CardMoney';
import CardPie from 'components/Card/CardPie';
import { formatCurrency } from 'utils/currency';
import { useEffect, useState } from "react";
import { createCancelToken } from "utils/http-common";
import dashboardService from "services/dashboard.service";

interface IValueDefaults{
  load:boolean;
  data:any;
}

export default function Home() {
  const { t } = useTranslation()
  const [ countCompanies, setCountCompanies ] = useState<IValueDefaults>({load:true,data:0});
  const [ totalBudget, setTotalBudget ] = useState<IValueDefaults>({load:true,data:0});
  const [ totalAction, setTotalAction ] = useState<IValueDefaults>({load:true,data:0});
  const [ budgetByCompany, setBudgetByCompany ] = useState<IValueDefaults>({load:true,data:[]});
  const [ budgetByCategory, setBudgetByCategory ] = useState<IValueDefaults>({load:true,data:[]});

  useEffect(()=>{
    const {token, cancel} = createCancelToken();

    dashboardService.countCompanies(token).then((data)=>{
      setCountCompanies({load:false,data})
    })
    dashboardService.totalBudget(token).then((data)=>{
      setTotalBudget({load:false,data})
    })
    dashboardService.totalAction(token).then((data)=>{
      setTotalAction({load:false,data})
    })
    dashboardService.budgetByCompany(token).then((data)=>{
      setBudgetByCompany({load:false,data})
    });
    dashboardService.budgetByCategory(token).then((data)=>{
      setBudgetByCategory({load:false,data})
    });

    return () => {
      cancel();
    }
    
  },[]);
  

  return (
    <PageDefault title={t('title:dashboard')}>
      <PageDefault.Title>{t('title:dashboard')}</PageDefault.Title>
      <Container>
        <CardArea>
          <CardSimple title="Marcas" md={3} xs={6} load={countCompanies.load}>{countCompanies.data}</CardSimple>
          <CardMoney title="Verba Total" md={3} xs={6} load={totalBudget.load} value={totalBudget.data}></CardMoney>
          <CardMoney title="Gasto Total" md={3} xs={6} load={totalAction.load} value={totalAction.data}></CardMoney>
          <CardMoney title="Saldo Disponível" md={3} xs={6} load={totalAction.load || countCompanies.load} value={totalBudget.data - totalAction.data}></CardMoney>
        </CardArea>
        <CardArea>
          <CardPie md={6} load={budgetByCompany.load} title="Verba por Marca" values={budgetByCompany.data}
            tooltipCallbackLabel={(context)=>{
              return `${context.label}: ${formatCurrency(context.parsed)}`;
            }}
          ></CardPie>
          <CardPie md={6} load={budgetByCategory.load} title="Gasto por Atividade" values={budgetByCategory.data}
            tooltipCallbackLabel={(context)=>{
              return `${context.label}: ${formatCurrency(context.parsed)}`;
            }}
          ></CardPie>
        </CardArea>
      </Container>
    </PageDefault>
  );
};
